<template>
  <custom-single-select-field
    v-if="showComponent && onReady" 
    :key="componentRefresh"
    :ref="`ks-custom-single-select-field-${_uid}`"
    :optionPlaceholder="optionPlaceholder"
    :optionNodes="optionNodes"
    :enableSearch="enableSearch"
    :enableDBSearch="enableDBSearch"
    :parentId="parentId"
    :childId="childId"
    :maxHeight="maxHeight"
    :tooltip="tooltip"
    :tooltipIcon="tooltipIcon"
    :tooltipRight="tooltipRight"
    :tooltipLeft="tooltipLeft"
    :inLine="inLine"
    :inlineLabelColClass="inlineLabelColClass"
    :label="label"
    :options="options"
    :required="required"
    :disabled="disabled||!enableComponent"
    :optionValue="optionValue"
    :optionLabel="optionLabel"
    :optionFilter="optionFilter"
    :size="size"
    :showNewOption="showNewOption"
    :newOptionLabel="newOptionLabel"
    :showNullOption="showNullOption"
    :nullOptionLabel="nullOptionLabel"
    :validation="validation"
    :validationOnChange="validationOnChange"
    :helpText="helpText"
    v-model="input"

    @onMounted="selectorMounted"
    @onChange="onChange"
    @onNewClick="onNewClick"
  />
</template>

<script>
import Vuex from 'vuex';
import checkPermissions from '../../../mixins/checkPermissions';
import dataproviderOptionsValidation from './../mixins/index.js';
import custom_single_select_field from './../selector-types/custom-single-select-field';

export default {

  name: "ks-custom-single-select-field",
  mixins: [checkPermissions, dataproviderOptionsValidation],
  components: {
    'custom-single-select-field': custom_single_select_field
  },
  props: {
    dataSource: {
      type: String,
      required: true
    },
    defaultValue: {},
    validation: {
      type: Function,
      default: null
    },
    validationOnChange: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: null
    },
    optionPlaceholder: {
      type: String,
      default: ''
    },
    optionNodes: {
      type: String,
      default: null
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    enableDBSearch: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: String,
      default: 'parent_id'
    },
    childId: {
      type: String,
      default: 'id'
    },
    maxHeight: {
      type: String,
      default: "650px"
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    tooltipRight: {
      type: Boolean,
      default: false
    },
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number
    },
    inLine: {
      type: Boolean,
      default: false
    },
    inlineLabelColClass: {
      type: String,
      default: 'col'
    },
    label: {
      type: String,
      default: null
    },
    options: {
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionValue: {
      type: String,
      required: true //define prop name for take value
    },
    optionLabel: { // define prop name for take label
      type: String,
      required: true 
    },
    optionFilter: {
      default: null //function to filter
    },
    size: {
      type: String, //sm-lg-md
      default: null
    },
    showNewOption: {
      type: Boolean,
      default: false
    },
    newOptionLabel: {
      type: String,
      default: "New"
    },
    showNullOption: {
      type: Boolean,
      default: false
    },
    nullOptionLabel:{
      type: String,
      default: "None"
    },
    returnType:{
      type: String,
      default: null
    }
  },
  watch: {
    input: function (val, oldVal) {
      //enable for testing
    },
    defaultValue: function (val){
      this.input = val;
    }
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.inputType === 'list') {
          return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
        } else {
          if (this.returnType === "string") {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource] ? this.$parent.data_provider_ref[this.inputType][this.dataSource].toString() : '';
          } else {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource];
          }
        }
      },
      set(newval) {
        if (this.inputType === 'list') {
          this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
        } else {
          this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
        }
      }
    }
  },
  methods:{
    validate_input(){
      return this.$refs[`ks-custom-single-select-field-${this._uid}`]?.validate_input();
    },
    selectorMounted(evt){
      setTimeout(() =>{
        if (typeof this.defaultValue !== 'undefined') {
          this.input = this.defaultValue;
        }
        this.$parent.data_provider_ref.inputs[this.dataSource] = this;
        this.$emit('onMounted', this);
      }, 100);
    },
    onNewClick(evt){
      this.$emit('onNewClick', this);
    },
    onChange(evt){
      this.$emit('onChange', this);
    }
  }
}
</script>
